import React from 'react';
import {
  Alert,
  AlertIcon,
  Box,
  Flex,
  HStack,
  Text,
  VStack,
  IconButton,
  useDisclosure,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerBody,
} from '@chakra-ui/react';
import { FiMenu } from 'react-icons/fi';
import SaktiSidebar from '../components/SaktiSidebar';
import SaktiBccFilterBar from '../components/SaktiBccFilterBar';
import SaktiBccKpiCards from '../components/SaktiBccKpiCards';
import SaktiBccTabsTable from '../components/SaktiBccTabsTable';
import SaktiBccDetailModal from '../components/SaktiBccDetailModal';
import { useSaktiBccDashboard } from '../hooks/useSaktiBccDashboard';
import { SAKTI_UI_SIZE } from '../uiSizes';
import { SaktiBccListItem, SaktiBaListItem } from '../types';

const SaktiBccPage: React.FC = () => {
  const {
    options,
    loadingOptions,
    loadingKpi,
    loadingTable,
    activeTab,
    draftFilters,
    kpi,
    rows,
    pagination,
    tableError,
    onDraftFilterChange,
    applyFilters,
    setActiveTab,
    goToPage,
  } = useSaktiBccDashboard();

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedItem, setSelectedItem] = React.useState<SaktiBccListItem | SaktiBaListItem | null>(null);

  const { 
    isOpen: isMobileSidebarOpen, 
    onOpen: onMobileSidebarOpen, 
    onClose: onMobileSidebarClose 
  } = useDisclosure();

  return (
    <Box minH="100vh" bg="#ECEEF1">
      <Flex align="stretch">
        <Box display={{ base: 'none', xl: 'block' }}>
          <SaktiSidebar activeMenu="bcc" />
        </Box>

        <Drawer isOpen={isMobileSidebarOpen} placement="left" onClose={onMobileSidebarClose} size="xs">
          <DrawerOverlay />
          <DrawerContent>
            <DrawerCloseButton zIndex={10} color="gray.500" />
            <DrawerBody p={0}><SaktiSidebar activeMenu="bcc" /></DrawerBody>
          </DrawerContent>
        </Drawer>

        <Box flex={1} p={SAKTI_UI_SIZE.pagePadding}>
          <VStack align="stretch" spacing={SAKTI_UI_SIZE.sectionGap}>
            <HStack justify="space-between" align={{ base: 'start', md: 'center' }} flexWrap="wrap">
              <HStack spacing={3} align="center">
                <IconButton aria-label="Menu" icon={<FiMenu />} variant="outline" bg="white" display={{ base: 'flex', xl: 'none' }} onClick={onMobileSidebarOpen} />
                <VStack align="start" spacing={0}>
                  <Text fontSize={SAKTI_UI_SIZE.pageTitle} fontWeight="bold" color="gray.900">BCC (Buku Catatan Cetak)</Text>
                  <Text color="gray.600" fontSize="sm">Hasil panen per pemanen · per blok · per TPH</Text>
                </VStack>
              </HStack>
            </HStack>

            <SaktiBccFilterBar filters={draftFilters} options={options} onFiltersChange={onDraftFilterChange} onApply={applyFilters} isApplying={loadingOptions || loadingTable} />
            <SaktiBccKpiCards loading={loadingKpi || loadingOptions} data={kpi} />

            {tableError && <Alert status="warning" borderRadius="lg"><AlertIcon />{tableError}</Alert>}

            <SaktiBccTabsTable
              loading={loadingTable || loadingOptions}
              activeTab={activeTab}
              rows={rows}
              pagination={pagination}
              onTabChange={setActiveTab}
              onPageChange={goToPage}
              onViewDetail={(id) => {
                const item = rows.find(r => r.id === id);
                if (item) {
                    setSelectedItem(item);
                    onOpen();
                }
              }}
              onEdit={(id) => console.log('Edit', id)}
            />
          </VStack>
        </Box>
      </Flex>

      <SaktiBccDetailModal
        isOpen={isOpen}
        onClose={onClose}
        data={selectedItem}
      />
    </Box>
  );
};

export default SaktiBccPage;
